import Vue from 'vue'
import Vuex, { GetterTree, MutationTree, ActionTree } from 'vuex'
Vue.use(Vuex)

interface State {
  orderId: string;
  amount: number;
  shipping: number;
}

const getDefaultState = (): State => {
  return {
    orderId: '',
    amount: 0,
    shipping: 150
  }
}
const state = getDefaultState()

const getters: GetterTree<State, any> = {
  orderId (state: State) {
    return state.orderId
  },
  amount (state: State) {
    return state.amount
  },
  shipping (state: State) {
    return state.shipping
  }
}

const mutations: MutationTree<State> = {
  SET_ORDER (state: State, payload: State) {
    state.orderId = payload.orderId
    state.amount = payload.amount
    state.shipping = payload.shipping
  }
}

const actions: ActionTree<State, any> = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
